"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_1 = require("react");
var SharedWidgets_1 = require("../SharedWidgets");
var TabStyles_1 = require("../styles/TabStyles");
var Declarative_1 = require("../utils/Declarative");
var ColorGridWidget_1 = require("./ColorGridWidget");
var HexColorInput = /** @class */ (function (_super) {
    tslib_1.__extends(HexColorInput, _super);
    function HexColorInput(props) {
        var _this = _super.call(this, props) || this;
        _this.hexColorRegExp = /^#?[0-9A-Fa-f]{6}$/;
        _this.onHandleClearText = function () {
            _this.setState({ hexColorText: '#' });
        };
        _this.onHexColorInput = function (text) {
            _this.setState({ hexColorText: text });
        };
        _this.onColorInputEnter = function () {
            if (_this.isAHexColor(_this.state.hexColorText)) {
                _this.props.onColorSelected(_this.prependHash(_this.state.hexColorText));
            }
        };
        _this.handleSwatchClicked = function (color) {
            if (_this.isAHexColor(_this.state.hexColorText)) {
                _this.props.onColorSelected(_this.prependHash(color.toLowerCase()));
            }
        };
        _this.isAHexColor = function (text) {
            return _this.hexColorRegExp.test(text);
        };
        _this.removeHash = function (color) {
            if (color !== null && color.charAt(0) === '#') {
                color = color.slice(1);
            }
            return color;
        };
        _this.prependHash = function (color) {
            if (color !== null && color.charAt(0) !== '#') {
                color = '#' + color;
            }
            return color;
        };
        _this.state = { hexColorText: _this.shouldDisplayCustomColor() ? _this.removeHash(props.selectedColor.toUpperCase()) : '#' };
        return _this;
    }
    HexColorInput.prototype.render = function () {
        var hexColorInputProps = {
            handleEnter: this.onColorInputEnter,
            handleChange: this.onHexColorInput,
            handleClearText: this.onHandleClearText,
            placeholder: '#',
            text: this.state.hexColorText || '#',
            hasError: this.state.hexColorText !== '#' ? !this.isAHexColor(this.state.hexColorText) : false,
            containerStyle: {
                display: 'inline-flex',
                paddingLeft: TabStyles_1.TabStyles.Spacing.DefaultSpace,
                flexGrow: 1,
                width: '100%'
            },
            testId: this.props.testId
        };
        // we set min height/width so that IE doesn't shrink the width of the box to less than row height
        // see Defect 736928 for more details
        var previewStyle = {
            height: TabStyles_1.TabStyles.Sizing.RowHeight,
            width: TabStyles_1.TabStyles.Sizing.RowHeight,
            minHeight: TabStyles_1.TabStyles.Sizing.RowHeight,
            minWidth: TabStyles_1.TabStyles.Sizing.RowHeight,
            borderWidth: TabStyles_1.TabStyles.Sizing.BorderWidth,
            borderStyle: 'solid',
            borderColor: TabStyles_1.TabStyles.Colors.L6,
            boxSizing: 'border-box',
            marginRight: 6
        };
        var colorSwatchProps = {
            color: this.getCustomColor() || 'transparent',
            handleClick: this.handleSwatchClicked,
            size: TabStyles_1.TabStyles.Sizing.RowHeight - 2 * TabStyles_1.TabStyles.Sizing.BorderWidth,
            selected: this.shouldSwatchBeSelected(),
            disabled: !this.getCustomColor(),
            testId: this.props.testId
        };
        return (react_1.createElement('div', {
            style: { display: 'flex', flexGrow: 1, paddingTop: TabStyles_1.TabStyles.Spacing.DefaultSpace },
            'data-tb-test-id': Declarative_1.testId(this.props.testId, 'HexInput')
        }, react_1.createElement('div', { style: previewStyle }, react_1.createElement(ColorGridWidget_1.ColorSwatchWidget, colorSwatchProps)), react_1.createElement(SharedWidgets_1.OutlineTextFieldWidget, hexColorInputProps)));
    };
    HexColorInput.prototype.getCustomColor = function () {
        if (this.state.hexColorText !== '#' && this.isAHexColor(this.state.hexColorText)) {
            return this.prependHash(this.state.hexColorText);
        }
        return null;
    };
    HexColorInput.prototype.shouldDisplayCustomColor = function () {
        return this.props.selectedColor.length !== 0;
    };
    HexColorInput.prototype.shouldSwatchBeSelected = function () {
        return this.shouldDisplayCustomColor() && this.prependHash(this.state.hexColorText.toLowerCase()) === this.props.selectedColor;
    };
    return HexColorInput;
}(React.Component));
exports.HexColorInput = HexColorInput;
//# sourceMappingURL=HexColorInputWidget.js.map